<app-evida-error [showRetryButton]="false">
    <h2 [innerHtml]="'shared.errormessages.status503.title' | translate"></h2>
    <span class="body-header">{{ 'shared.errormessages.supportinformations' | translate }}</span>
    <p [innerHtml]="'shared.errormessages.status503.description' | translate"></p>
</app-evida-error>
